export default __webpack_public_path__ + "static/media/sanitair.6f95091e.svg";